import React, { ReactElement, useEffect } from 'react';
import { LoaderButton } from 'idsk-react-components';
import downloadIcon from '../../../../../assets/images/icon-download.svg';
import { useClient } from '../../../../context/ClientStatusContext';
import {
  fetchSprievodneDokumentyZip,
} from '../../../../client/external/evidencnaaplikacia/sprievodnyDokumentZipClient';
import downloadFile from '../../../../function/downloadFile';
import Uuid from '../../../../model/Uuid';

interface Props {
  legMaterialUuid: Uuid;
  stadiumUuid: Uuid;
}

export default function DownloadSprievodnyDokumentListButton({
  legMaterialUuid,
  stadiumUuid,
}: Props): ReactElement {
  const {
    wrapClient: fetchSprievodneDokumenty,
    status: fetchSprievodneDokumentyStatus,
    data: zippedFile,
  } = useClient(fetchSprievodneDokumentyZip);

  const download = async (): Promise<void> => {
    await fetchSprievodneDokumenty(legMaterialUuid, stadiumUuid);
  };

  useEffect(() => {
    if (zippedFile) {
      const file = zippedFile;
      downloadFile(file.fileName, file.blob);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zippedFile]);

  return (
    <LoaderButton
      customIconBefore={downloadIcon}
      buttonStyle="third"
      size="large"
      className="download-sprievodny-dokument-list-button"
      loading={fetchSprievodneDokumentyStatus.loading}
      onClick={download}
      disableOutsideClickWhileLoading
    >Stiahnuť všetky
    </LoaderButton>
  );
}
